import CancelMRETable from '../components/CancelMRETable';
import WaitingMRETable from '../components/WaitingMRETable';

const WaitingMREPage = () => {
    return (
        <div className="p-2 md:p-10 bg-white dark:border-gray-700 dark:bg-gray-800 rounded-2xl">
            <div className="mb-5">
                <div className="flex justify-items-center">
                    <h1 className="text-lg leading-10 grow font-medium truncate mr-5 dark:text-gray-300">
                        Waiting MRE
                    </h1>
                </div>
                <div className="mt-3">
                    <WaitingMRETable />
                </div>
            </div>
            <div className="mb-5">
                <div className="flex justify-items-center">
                    <h1 className="text-lg leading-10 grow font-medium truncate mr-5 dark:text-gray-300">
                        Cancel MRE
                    </h1>
                </div>
                <div className="mt-3">
                    <CancelMRETable />
                </div>
            </div>
        </div>
    );
};

export default WaitingMREPage;
